import { Routes } from '@angular/router';

export const LANDING_PATHS = {
  BASE: 'landing'
};

export const LandingRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing/landing.page').then((m) => m.LandingPage)
  }
];
